var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.442 75.7839C161.442 75.7839 140.778 93.2005 162.779 132.111C182.318 166.666 135.627 180.301 115.82 175.862C90.162 170.112 76.3462 136.667 56.287 146.668C36.2278 156.67 18.1151 108.69 47.3607 91.91C83.7413 71.0363 61.2007 57.841 64.8934 41.9759C67.5434 30.5895 100.847 13.6968 117.902 34.3082C132.253 51.6523 139.728 45.7547 146.592 43.6533C156.491 40.6223 177.366 58.1512 161.442 75.7839Z",
    fill: "#EEF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.155 50.2398L92.569 42.9337C89.2989 42.3979 86.2136 44.6144 85.6777 47.8845L70.256 141.997C69.7202 145.267 71.9367 148.353 75.2068 148.888L119.793 156.194C123.063 156.73 126.148 154.514 126.684 151.244L142.106 57.131C142.642 53.8609 140.425 50.7756 137.155 50.2398Z",
    fill: "#1B1D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.689 52.8922L93.1117 45.9154C90.9316 45.5581 88.8747 47.0358 88.5175 49.2159L73.3722 141.642C73.015 143.822 74.4927 145.879 76.6728 146.236L119.25 153.213C121.43 153.57 123.487 152.092 123.844 149.912L138.989 57.4864C139.346 55.3063 137.869 53.2494 135.689 52.8922Z",
    fill: "#363BC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4579_20821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.379 98.3987L100.144 96.7189M102.436 104.102L99.024 103.543M114.911 92.135L101.264 89.8953M120.755 99.2255L121.79 92.9136C122.261 90.0474 122.496 88.6143 122.118 87.4281C121.785 86.3846 121.131 85.4732 120.248 84.8245C119.245 84.087 117.812 83.8518 114.946 83.3815L104.028 81.5897C101.162 81.1194 99.7289 80.8842 98.5426 81.2623C97.4991 81.5949 96.5877 82.2493 95.9391 83.1318C95.2016 84.135 94.9664 85.5681 94.496 88.4343L91.5845 106.176C91.1141 109.042 90.8789 110.475 91.257 111.661C91.5897 112.705 92.2441 113.616 93.1265 114.265C94.1297 115.002 95.5628 115.237 98.429 115.708L103.035 116.464M120.947 119.403L118.808 116.424M121.214 112.44C120.673 115.737 117.561 117.972 114.263 117.43C110.966 116.889 108.731 113.777 109.272 110.48C109.814 107.182 112.926 104.948 116.223 105.489C119.521 106.03 121.755 109.142 121.214 112.44Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4579_20821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4894,
    height: 41.4894,
    fill: "white",
    transform: "translate(89.5762 75.7143) rotate(9.31985)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.64d1c9faf09ba5cebfdbb7ba84517a37.svg";
export { ForwardRef as ReactComponent };